/* eslint-disable no-unused-vars */
import { FC, useEffect, useState } from "react";

export enum SpinnerType {
  Circular = "circular",
  Cross = "cross",
}

interface SpinnerProps {
  size?: string;
  color?: string;
  type?: SpinnerType;
}

export const Spinner: FC<SpinnerProps> = ({
  size = "40",
  color = "currentColor",
  type = SpinnerType.Circular,
}) => {
  const sizePx = `${size}px`;
  const borderSize = Math.max(parseInt(size) * 0.1, 4);
  const innerSizePx = `${parseInt(size) - borderSize * 2}px`;

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % 8);
    }, 125);
    return () => clearInterval(interval);
  }, []);

  const circularSpinner = () => (
    <div
      className="relative flex items-center justify-center"
      style={{ width: sizePx, height: sizePx }}
    >
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="absolute animate-spin rounded-full border-solid"
          style={{
            width: innerSizePx,
            height: innerSizePx,
            borderWidth: `${borderSize}px`,
            borderColor: `${color} transparent transparent transparent`,
            animationDelay: `-${index * 0.15}s`,
          }}
        />
      ))}
    </div>
  );

  const crossSpinner = () => (
    <div
      className="relative flex items-center justify-center"
      style={{ width: sizePx, height: sizePx, position: "relative" }}
    >
      {[...Array(8)].map((_, index) => (
        <div
          key={index}
          className="absolute"
          style={{
            width: `4px`,
            height: `12px`,
            backgroundColor: index === activeIndex ? color : "white",
            borderRadius: "9px",
            position: "absolute",
            transform: `rotate(${index * 45}deg) translateY(-20px)`,
            transformOrigin: "50% 50%",
            animation: `spinner-fade 1s ease-in-out infinite`,
            animationDelay: `${index * 0.125}s`,
          }}
        />
      ))}
    </div>
  );

  return type === SpinnerType.Circular ? circularSpinner() : crossSpinner();
};
